module.exports = __webpack_public_path__ + "img/4075432bd7d357d5f1d9c94216148964.png";